// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3YJOH","content":"GlobalSearch_content__172by"};